
import { Component, Vue } from 'vue-property-decorator';
import CpuTab from '@/views/pages/usage/components/CpuTab.vue';
import DiskUsageTab from '@/views/pages/usage/components/DiskUsageTab.vue';
import { QuotaAndGroupUsage, UsageRepositoryInterface } from '@/services/Usage/interfaces';
import WebsiteGroupRepositoryInterface, { WebsiteGroup } from '@/services/WebsiteGroup/interfaces';
import WebsiteRepositoryInterface, { Website } from '@/services/Website/interfaces';
import { PlanInterface, PlanRepositoryInterface } from '@/services/Plan/interfaces';
import BandwidthTab from "@/views/pages/usage/components/BandwidthTab.vue";
import PageHeader from '@/components/layout/PageHeader.vue';

@Component({
  components: {
    PageHeader,
    CpuTab,
    DiskUsageTab,
    BandwidthTab,
  },
  inject: [
    'usageRepository',
    'websiteGroupRepository',
    'websiteRepository',
    'planRepository',
  ],
})
export default class UsagePage extends Vue {
  private readonly usageRepository!: UsageRepositoryInterface;
  private readonly websiteGroupRepository!: WebsiteGroupRepositoryInterface;
  private readonly websiteRepository!: WebsiteRepositoryInterface;
  private readonly planRepository!: PlanRepositoryInterface;

  private group: WebsiteGroup | null = null;
  private mainWebsiteData: Website | null = null;
  private planData: PlanInterface | null = null;
  private systemUserId: number | null = null;

  private activeTab = 0;
  private diskUsage: QuotaAndGroupUsage | null = null;
  private loadingDisk = false;
  private diskError: string | null = null;

  get groupId(): number {
    return Number(this.$route.params.groupId);
  }

  get mainWebsite(): string {
    return this.mainWebsiteData?.domain || 'N/A';
  }

  get plan(): string {
    return this.planData?.name || 'N/A';
  }

  get systemUser(): string {
    return this.systemUserId ? String(this.systemUserId) : '';
  }

  async mounted(): Promise<void> {
    await Promise.all([
      this.loadHeaderData(),
      this.loadDiskUsage(),
    ]);
  }

  private async loadHeaderData(): Promise<void> {
    try {
      this.group = await this.websiteGroupRepository.getGroup(this.groupId);

      this.mainWebsiteData =
        this.group.websites.find((w) => w.id === this.group?.mainWebsite) || null;

      this.planData = await this.planRepository.getOneById(this.group.plan);

      if (this.mainWebsiteData) {
        const website = await this.websiteRepository.getWebsiteById(this.mainWebsiteData.id);
        this.systemUserId = website?.details?.unixUserId || null;
      }
    } catch (e) {
      console.error('Failed to load usage header data', e);
    }
  }

  private async loadDiskUsage(): Promise<void> {
    this.loadingDisk = true;
    this.diskError = null;

    try {
      this.diskUsage = await this.usageRepository.getDiskUsageByGroup(this.groupId);
    } catch (e: any) {
      this.diskUsage = null;
      this.diskError = e?.message || 'Failed to load disk usage';
    } finally {
      this.loadingDisk = false;
    }
  }
}
